module.exports = __webpack_public_path__ + "img/Group 12.e413edd0.png";